var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"scroll-indicator-wrapper",on:{"click":function($event){$event.preventDefault();return _vm.scrollDown.apply(null, arguments)}}},[(_vm.show)?_c('div',{staticClass:"scroll-indicator bounce icon icon--arrow-down"},[_c('span',[_vm._v("Scroll for content")])]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }